import React, { useState } from "react";
import "./TableList.scss";

export interface TableListProps {
    headers: TableListHeader[];
    data: TableListRow[];
    disabled?: boolean;
};

export type TableListHeader = string;

export interface TableListRow {
    values: (string | JSX.Element)[];
    onClick?: () => void;
}

const TableList = ({ disabled, headers, data }: TableListProps) => {
    const [hoveredRowIndex, setHoveredRowIndex] = useState(null);

    return (
        <div className="table-list">
            <div className={`table-header ${hoveredRowIndex === 0 ? 'table-header-hover-active' : ''}`}>
                {headers.map((header, index) => (
                    <div key={index} className="header">
                        {header}
                    </div>
                ))}
            </div>
            <div className="table-body">
                {data?.map((row, index) => {
                    const onMouseEnter = () => setHoveredRowIndex(index);
                    const onMouseLeave = () => setHoveredRowIndex(null);

                    const onRowClick = () => {
                        if (disabled) return;
                        if (row?.onClick)
                            row?.onClick();
                    }

                    return (
                        <div
                            key={index}
                            className={`row ${index === hoveredRowIndex || index === hoveredRowIndex - 1 ? 'row-hovered' : ''} disabled-${disabled}`}
                            onClick={onRowClick}
                            onMouseEnter={onMouseEnter}
                            onMouseLeave={onMouseLeave}
                        >
                            {row?.values?.map((cell, index) => (
                                <div key={index} className="cell">
                                    {cell}
                                </div>
                            ))}
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

export default TableList;